import {type FC} from 'react';
import type {Boroughs} from '../types';
import {Icon, Item} from '../types/VideoCallPage.styled.ts';
import useVideoCallStore from '../../../store/useVideoCallStore.ts';
import {getCurrentFocusKey, setFocus, useFocusable} from '@noriginmedia/norigin-spatial-navigation';
import 강화군 from '../../../assets/video_call/강화군.png';
import 검단구 from '../../../assets/video_call/검단구.png';
import 계양구 from '../../../assets/video_call/계양구1.png';
import 남동구 from '../../../assets/video_call/남동구1.png';
import 동구 from '../../../assets/video_call/동구1.png';
import 미추홀구 from '../../../assets/video_call/미추홀구1.png';
import 부평구 from '../../../assets/video_call/부평구1.png';
import 서구 from '../../../assets/video_call/서구1.png';
import 서해구 from '../../../assets/video_call/서해구.png';
import 중구 from '../../../assets/video_call/중구1.png';
import 연수구 from '../../../assets/video_call/연수구1.png';
import 영종구 from '../../../assets/video_call/영종구.png';
import 제물포구 from '../../../assets/video_call/제물포구.png';
import all from '../../../assets/video_call/all1.png';

interface BoroughWrapperProps {
    item: Boroughs;
}

const goTopIndex = ['2', '4', '5'];

const boroughImages: Record<string, string> = {
    강화군: 강화군,
    검단구: 검단구,
    계양구: 계양구,
    남동구: 남동구,
    동구: 동구,
    미추홀구: 미추홀구,
    부평구: 부평구,
    서구: 서구,
    서해구: 서해구,
    중구: 중구,
    연수구: 연수구,
    영종구: 영종구,
    제물포구: 제물포구,
    all: all,
};

const BoroughWrapper: FC<BoroughWrapperProps> = ({item}) => {
    const {handleRowClick} = useVideoCallStore();

    const {ref, focused} = useFocusable({
        focusKey: `${item.id}-${item.name}`,
        onEnterPress: () => {
            handleRowClick(item);
            setFocus('video-call-detail-page');
        },
        onArrowPress: (direction) => {
            if (direction === 'up' && goTopIndex.includes(getCurrentFocusKey().split('-')[0])) {
                setFocus('videoCall');
                return false;
            }
            return true;
        },
    });

    const backgroundImage = boroughImages[item.name];

    return (
        <Item
            key={item.id}
            $active={item.active}
            ref={ref}
            $focused={focused}
            $backgroundImage={backgroundImage}
            onClick={() => handleRowClick(item)}
        >
            <span style={{fontSize: '5rem', color: 'rgba(255, 255, 255, 0.8)'}}>
                {item.name === 'all' ? '전체 보기' : item.name}
            </span>
            {item.name === 'all' && <Icon />}
        </Item>
    );
};

export default BoroughWrapper;
